export default __webpack_public_path__ + "static/media/blog-2.02757a5f.png";